<template>
  <div id="app">
    <inspur-map></inspur-map>
    <div class="middle-cover"></div>
    <div class="mian-container">
      <router-view />
    </div>
  </div>
</template>

<script>
import InspurMap from '@/components/map/InspurMap.vue'
export default {
  components: {
    InspurMap
  }
}
</script>
<style lang="scss">
#app {
  width: 100%;
  height: 100%;
  .middle-cover {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    z-index: 1;
    pointer-events: none;
    background: url('./assets/middle-cover.png') no-repeat;
    background-size: 100% 100%;
  }
  .mian-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    z-index: 10;
    pointer-events: none;
  }
}
</style>
